(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
/* ---- HERO SLIDER ---- */
const slides = document.querySelectorAll('.hero-slide');
const dots = document.querySelectorAll('.slider-dot');
let current = 0;
let autoTimer = null;

function goToSlide(n) {
  slides[current].classList.remove('active');
  dots[current].classList.remove('active');
  current = (n + slides.length) % slides.length;
  slides[current].classList.add('active');
  dots[current].classList.add('active');
  const arrows = document.querySelectorAll('.slider-arrow');
  if (slides[current].classList.contains('light')) {
    arrows.forEach(a => a.classList.add('lt-arrow'));
    dots.forEach(d => d.classList.add('dark-dot'));
  } else {
    arrows.forEach(a => a.classList.remove('lt-arrow'));
    dots.forEach(d => d.classList.remove('dark-dot'));
  }
  resetAuto();
}

function changeSlide(dir) { goToSlide(current + dir); }

function resetAuto() {
  clearInterval(autoTimer);
  autoTimer = setInterval(() => changeSlide(1), 5000);
}

resetAuto();
  

/* ---- BLOG SLIDER ---- */
const blogTrack = document.getElementById('blogTrack');
const blogDotEls = document.querySelectorAll('.blog-dot');
const blogCards = document.querySelectorAll('.blog-card');
let blogCurrent = 0;
const blogVisible = 3;
const blogMax = blogCards.length - blogVisible;

function blogGoTo(n) {
  blogCurrent = Math.max(0, Math.min(n, blogMax));
  const gap = 20;
  const cardW = blogCards[0] ? blogCards[0].offsetWidth + gap : 0;
  blogTrack.style.transform = `translateX(-${blogCurrent * cardW}px)`;
  blogDotEls.forEach((d, i) => d.classList.toggle('active', i === blogCurrent));
}

function blogMove(dir) { blogGoTo(blogCurrent + dir); }

window.addEventListener('resize', () => blogGoTo(blogCurrent));


/* ---- HAMBURGER MENU ---- */
function toggleMobileMenu() {
  const btn = document.getElementById('hamBtn');
  const menu = document.getElementById('mobileMenu');
  if (!btn || !menu) return;
  const isOpen = menu.classList.contains('open');
  btn.classList.toggle('open', !isOpen);
  menu.classList.toggle('open', !isOpen);
  btn.setAttribute('aria-expanded', String(!isOpen));
  document.body.style.overflow = isOpen ? '' : 'hidden';
}

function toggleMobSection(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = body.classList.contains('open');
  document.querySelectorAll('.mob-section-body').forEach(b => b.classList.remove('open'));
  document.querySelectorAll('.mob-section-trigger').forEach(t => {
    t.classList.remove('open');
    t.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) {
    body.classList.add('open');
    trigger.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
  }
}

// Close mobile menu on outside tap
document.addEventListener('click', e => {
  const menu = document.getElementById('mobileMenu');
  const btn = document.getElementById('hamBtn');
  if (menu && menu.classList.contains('open') &&
      !menu.contains(e.target) && btn && !btn.contains(e.target)) {
    toggleMobileMenu();
  }
});


  } catch(e) { console.error(e); }
})();
})();
